import { ScaleIcon } from "@lucide/icons";

import { H3 } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";
import { Table, TableCell, TableRow } from "simplydo/react/ui/table";

import type { CompanyAiService } from "components/innointel/types";

import {
  InfoBoxWidget,
  InfoBoxWidgetTitleArea,
  InfoContainer,
} from "../Styles";

type CompanyServicesProps = { services: CompanyAiService[] };

const CompanyServices = ({ services }: CompanyServicesProps) => {
  if (services.length) {
    return (
      <InfoBoxWidget>
        <InfoBoxWidgetTitleArea>
          <Icon icon={ScaleIcon} />
          <div>
            <H3>Services</H3>
            <span>
              Products and/or services found from analysing the business website
            </span>
          </div>
        </InfoBoxWidgetTitleArea>
        <InfoContainer $wrapped>
          <Table definition>
            {services.map((service) => (
              <TableRow key={service.name ?? service.description}>
                <TableCell collapsing>{service.name}</TableCell>
                <TableCell>{service.description}</TableCell>
              </TableRow>
            ))}
          </Table>
        </InfoContainer>
      </InfoBoxWidget>
    );
  }
  return null;
};

export default CompanyServices;
